import React, { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import "./styles/Services.css";
import "./styles/Service-pages.css";

// Import service icons
import CollaborationSolutions from "../../assets/images/services/managed-services/collaborationSolutions.png";
import unifiedComm from "../../assets/images/services/managed-services/unifiedCommunicationpng.png";
import ContactCenter from "../../assets/images/services/managed-services/contactCenter.png";
import securitySolutions from "../../assets/images/services/managed-services/securitySolutions.png";
import connectivity from "../../assets/images/services/managed-services/connectivity.png";
import hybridCloudHosting from "../../assets/images/services/managed-services/hybridCloudHosting.png"
import cybersecurityInfra from "../../assets/images/services/managed-services/cybersecurityInfra.png";
import cloudInfra from "../../assets/images/services/infrastructure-services/cloudInfra.png";
import dataCenter from "../../assets/images/services/infrastructure-services/dataCenter.png";
import networkInfra from "../../assets/images/services/infrastructure-services/networkInfra.png";
import wirelessInfra from "../../assets/images/services/infrastructure-services/wirelessInfra.png";
import cablingSolutions from "../../assets/images/services/infrastructure-services/cablingSolutions.png";
import maritimeSystems from "../../assets/images/services/infrastructure-services/maritimeSystems.png";
import intelligentSmartCitiesSolutions from "../../assets/images/services/infrastructure-services/intelligentSmartCitiesSolutions.png"

const Services = () => {
  const tabs = useMemo(
    () => [
      { key: "managed", label: "MANAGED SERVICES" },
      { key: "infra", label: "INFRASTRUCTURE SERVICES" },
    ],
    []
  );

  // Add `category` to each service
  const serviceList = useMemo(
    () => [
      
      // MANAGED SERVICES
      {
        category: "managed",
        title: "Collaboration Solutions",
        description:
        "ComNetworks.net’s Channel Partner Program enables partners to offer advanced UCaaS solutions that enhance business communication and support client growth.",
        icon: CollaborationSolutions,
        link: "/services/Collaboration-Solutions",
        linkLabel: "Explore Collaboration Solutions",
      },
      {
        category: "managed",
        title: "Unified Communications as a service",
        description: "UCaaS (Unified Communications as a Service) enhances traditional VoIP by integrating voice with messaging, chat, video conferencing, screen sharing, and online meetings into one seamless communication platform.",
        icon: unifiedComm,
        link: "/services/Unified-Communications",
        linkLabel: "Explore Unified Communications",
      },
      {
        category: "managed",
        title: "Contact Center as a service",
        description: "CCaaS (Contact Center as a Service) solutions go beyond voice calls by supporting digital channels like chat and SMS, while offering scalable, globally accessible, and easily integrated customer service routing.",
        icon: ContactCenter,
        link: "/services/Contact-Center",
        linkLabel: "Explore Contact Center",
      },
      {
        category: "managed",
        title: "Security Solutions",
        description: "Our DDoS protection service safeguards digital assets and ensures uninterrupted operations, strengthened by advanced Syslog, SIEM, and next generation firewall solutions.",
        icon: securitySolutions,
        link: "/services/Security-Solutions",
        linkLabel: "Explore Security Solutions",
      },
      {
        category: "managed",
        title: "Connectivity",
        description: "Our software-defined networking (SDN) solutions optimize network performance by integrating broadband, dedicated internet, MPLS, Ethernet, private lines, wireless, fiber, and structured wiring into a seamless connectivity solution.",
        icon: connectivity,
        link: "/services/Connectivity",
        linkLabel: "Explore Connectivity services",
      },
      {
        category: "managed",
        title: "Hybrid Cloud Hosting",
        description:
        "ComNetworks analyzes your business needs to deliver tailored managed hybrid solutions, including mission-critical hosting, unified networking, cloud migration, disaster recovery, and fully managed public, private, or hybrid environments.",
        icon: hybridCloudHosting,
        link: "/services/Hybrid-Cloud-Hosting",
        linkLabel: "Explore Hybrid Cloud Hosting",
      },
      {
        category: "managed",
        title: "Cyber Security Infrastructure",
        description:
        "ComNetworks helps benchmark and improve the digital resilience of your network and security infrastructure through segmentation, intrusion protection, compliance support, WLAN auditing, penetration testing, and data security management.",
        icon: cybersecurityInfra,
        link: "/services/Cyber-Security-Infrastructure",
        linkLabel: "Explore Cyber Security Infrastructure",
      },
      // INFRASTRUCTURE SERVICES
      {
        category: "infra",
        title: "Cloud Infrastructure",
      description: "We deliver flexible private, public, and hybrid cloud solutions, colocation services, AI driven insights, and secure connectivity to AWS, Azure, and Google Cloud.",
      icon: cloudInfra,
      link: "/services/Cloud-Infrastructure",
      linkLabel: "Explore CloudInfrastructure Services",
    },
    {
      category: "infra",
      title: "Data Center Services",
      description:
        "ComNetworks delivers customized data center services such as system migration, hardware installation and maintenance, backup and archiving, network optimization, security management, and business continuity support.",
      icon: dataCenter,
      link: "/services/Data-Center-Services",
      linkLabel: "Explore Data Center Services",
    },
    {
      category: "infra",
      title: "Network Infrastructure",
      description:
      "ComNetworks begins with an on-site assessment of your IT infrastructure and works with you to design the right solution for data protection, implementation, monitoring, equipment, cabling, and disaster recovery.",
      icon: networkInfra,
      link: "/services/Network-Infrastructure",
      linkLabel: "Explore Network Infrastructure",
    },
    {
      category: "infra",
      title: "Wireless Infrastructure",
      description:
      "ComNetworks provides end-to-end services to design and deploy wireless networks for hotspots, broadband, VoIP, mesh networks, point-to-point and point-to-multipoint links, mobile access, and wireless surveillance.",
      icon: wirelessInfra,
      link: "/services/Wireless-Infrastructure",
      linkLabel: "Explore Wireless Infrastructure",
    },
    {
      category: "infra",
      title: "Cabling Solutions",
      description:
      "ComNetworks offers structured cabling solutions for voice, video, and data networks, supporting build-outs, rack systems, cable management, MAC work, and certified copper, fiber, and coaxial installations.",
      icon: cablingSolutions,
      link: "/services/Cabling-Solutions",
      linkLabel: "Explore Cabling Solutions",
    },
      {
        category: "infra",
        title: "Maritime Systems",
        description:
          "Our marine communications services provide reliable satellite and radio connectivity, along with security cameras, mobile communications, satellite TV, and fire alarm systems for enhanced safety and onboard support.",
        icon: maritimeSystems,
        link: "/services/Maritime-Systems",
        linkLabel: "Explore Maritime Systems",
      },
    {
      category: "infra",
      title: "Intelligent Smart Cities Solutions",
      description:
        "Our DDoS protection service safeguards digital assets and ensures uninterrupted operations, strengthened by advanced Syslog, SIEM, and next-generation firewall solutions.",
      icon: intelligentSmartCitiesSolutions,
      link: "/services/Intelligent-Smart-Cities-Solutions",
      linkLabel: "Explore Intelligent Smart Cities Solutions",
    },
    ],
    []
  );

  const [activeTab, setActiveTab] = useState(tabs[0].key);

  const filteredServices = useMemo(
    () => serviceList.filter((s) => s.category === activeTab),
    [serviceList, activeTab]
  );

  return (
    <section className="services">
      <div className="services__hero">
        <h1>Services</h1>
      </div>

      <div className="services__lead">
        <p>
          Our team combines deep expertise and attentive insight to deliver solutions
          that address your business’s critical challenges. We proactively navigate a
          dynamic business environment, applying precise strategies and proven methods
          at key moments to ensure lasting results and help your organization achieve
          its goals.
        </p>
      </div>

      {/* TABS (like image 1) */}
      <div className="servicesTabs">
        <div className="servicesTabs__inner">
          {tabs.map((t) => (
            <button
              key={t.key}
              type="button"
              className={`servicesTabs__tab ${
                activeTab === t.key ? "active" : ""
              }`}
              onClick={() => setActiveTab(t.key)}
            >
              {t.label}
            </button>
          ))}
        </div>
      </div>

      {/* GRID (filtered by tab) */}
      <div className="services__grid">
        {filteredServices.map((service, idx) => {
          const iconStr = String(service.icon || "");
          const isImg =
            iconStr.includes(".jpg") ||
            iconStr.includes(".jpeg") ||
            iconStr.includes(".png") ||
            iconStr.startsWith("data:image") ||
            iconStr.startsWith("blob:");

          return (
            <div key={idx} className="services__card">
              {isImg ? (
                <img
                  src={service.icon}
                  alt={service.title}
                  className="services__icon-img"
                />
              ) : (
                <span className="services__icon">{service.icon}</span>
              )}

              <h2>{service.title}</h2>
              <p>{service.description}</p>

              <Link to={service.link} className="services__link">
                {service.linkLabel}
              </Link>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default Services;
